import { Router } from "@frui.ts/screens";
import { bound } from "@frui.ts/helpers/dist";
import { computed } from "mobx";
import { Modules } from "config";
import RefundType from "entities/refundType";
import EventBus, { SEPATransferRefundUpdated } from "services/eventBus";
import LocalizationService from "services/localizationService";
import OptionsService from "services/optionsService";
import RefundRepository from "repositories/refundRepository";
import type CountrySelectViewModel from "../../../../countrySelectViewModel";
import TransferRefundsViewModel from "../transferRefundsViewModel";
import SEPARefundDetailViewModel from "./SEPARefundDetailViewModel";
import RefundsApprovalService from "services/refundsApprovalService";
import TransferPaymentType from "entities/transferPaymentType";
import Selectable, { SelectableListViewModel } from "../../../../selectableListViewModel";
import type TransferRefund from "entities/transferRefundResponse";

const navigationName = "SEPA";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [SEPARefundDetailViewModel],
})
@Selectable
export default class SEPARefundsViewModel extends TransferRefundsViewModel {
  readonly transferRefundType = TransferPaymentType.Sepa;
  readonly refundType = RefundType.SepaTransfer;

  constructor(
    protected detailViewModelFactory: ReturnType<typeof SEPARefundDetailViewModel.Factory>,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected approvalService: RefundsApprovalService,
    protected optionsService: OptionsService,
    protected repository: RefundRepository,
    protected countrySelectViewModelFactory: ReturnType<typeof CountrySelectViewModel.Factory>
  ) {
    super(
      detailViewModelFactory,
      localizationService,
      eventBus,
      approvalService,
      optionsService,
      repository,
      countrySelectViewModelFactory
    );
    this.navigationName = navigationName;
  }

  @computed
  get self(): SelectableListViewModel<SEPARefundsViewModel, TransferRefund> {
    return this as any;
  }

  protected processData(items: TransferRefund[]) {
    items.forEach(item => {
      item.isSelectable =
        item.permittedActions.approval.isAllowed && (this.canApprove(item) || false) && this.myApprovalStep(item);

      return item;
    });

    return items;
  }

  onInitialize() {
    this.unsubscriptions.push(this.eventBus.subscribe(SEPATransferRefundUpdated, this.loadData));
    return super.onInitialize();
  }

  @bound
  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `refundApprovals.SEPA.${code}`, size);
  }
}
